const ticketSocketEventNamespace = "ticket";
const ticketSocketEventTypeNames = ["redeemed", "reverted", "scanned"] as const;
type TicketSocketEventTypeName = (typeof ticketSocketEventTypeNames)[number];

export type { TicketSocketEventTypeName };
export { ticketSocketEventNamespace, ticketSocketEventTypeNames };
